import { LoadingState } from "./ui";

// Full-page loading state; children are an optional label
function PageLoader({ children }) {
  return <LoadingState label={children} style={{ minHeight: "200px" }} />;
}

export default PageLoader;
